import * as React from 'react';
import { EGDSLoader } from '@egds/react-core/loader';

export interface VacLoaderComponentProps {
  isLoading: boolean;
}
export const VacLoaderComponent: React.FC<VacLoaderComponentProps> = (props: VacLoaderComponentProps) => {
  return props.isLoading ? (
    <div className={'vacLoader'}>
      <EGDSLoader />
    </div>
  ) : null;
};

VacLoaderComponent.displayName = 'VacLoaderComponent';
